<template>
  <div class="filters--industries hide-filter">
    <div class="subcategories-sidebar">
      <h4><a data-toggle="collapse" href="#sub_industry_filter" role="button" aria-expanded="true" aria-controls="sub_industry_filter"  class="filter-toggle">{{filterTitle}}</a></h4>
      <div class="collapse show" id="sub_industry_filter">
        <template v-for="filter in availableSubIndustriesIds">
            <!-- <div class="radio" v-bind:key="filter.id"
                v-bind:class="{'active': selectedSubIndustryId === filter.id }"
                v-on:click="onSubIndustrySelect($event, filter)"
                v-if="filter.counter !== 0">
                <input type="radio" name="industry"
                      v-bind:id="'industry-' + filter.id"
                      v-bind:value="filter.id">
                <label v-bind:for="'industry-' + filter.id">{{ filter.label }}</label>
                <span class="disable" v-if="selectedSubIndustryId === filter.id">x</span>
                <span class="counter" v-if="selectedSubIndustryId !== filter.id">({{ filter.counter }})</span>
            </div> -->
            <div class="radio"
                v-bind:key="filter.id"
                v-bind:class="{ 'active': selectedSubIndustryId === filter.id }"
                v-on:click="onSubIndustrySelect($event, filter)"
                v-if="filter.counter !== 0">
                <input
                  type="radio"
                  name="industry"
                  v-model="selectedSubIndustryId"
                  v-bind:id="'industry-' + filter.id"
                  v-bind:value="filter.id"
                  class="custom-radio"
                />
                <label v-bind:for="'industry-' + filter.id">{{ filter.label }}</label>
                <span class="disable" v-if="selectedSubIndustryId === filter.id">x</span>
                <span class="counter" v-if="selectedSubIndustryId !== filter.id">
                  ({{ filter.counter }})
                </span>
              </div>
        </template>
        <button class="filter-reset-btn" @click="toggleFilter()">Reset Filter</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubIndustryFilter',
  props: {
    availableSubIndustriesIds: Array,
    selectedSubIndustry: String,
  },
  data() {
    return {
      filterTitle: 'Filters',
      selectedSubIndustryId: '',
    }
  },
  watch: {
    selectedSubIndustry: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedSubIndustryId = val;
          this.$emit('clearselectedSubIndustry');
        }
      }
    }
  },
  methods: {
    toggleFilter: function () {
      this.$emit("toggleFilter");
    },
    onSubIndustrySelect: function (event, industry) {
      event.preventDefault();

      if (this.selectedSubIndustryId === industry.id) {
        this.selectedSubIndustryId = '';
        this.$emit("clearAllSubFilters");
      } else {
        this.selectedSubIndustryId = industry.id;
        var filters =  [...industry.parents, industry.id];
        this.$emit("applySubIndustryFilters", filters);
      }
    }
  }
}
</script>